import { CancelTokenSource } from 'axios'
import {
	IDsmesBillableSessions,
	IDsmesClients,
	IDsmesConference,
	IDsmesDashboardCounts,
	IDsmesParams,
	IDsmesPatientEnrolled,
	IDsmesSessionCompleted,
} from './Dsmes.Intefaces'
import _ from 'lodash'
import axios from 'services/axios'
import { ENDPOINTS } from 'const/endpoints'
import { commonMessages } from 'utils/messages'
import { onCreateEndpointsWithClientid } from 'utils/common'
import { IPagination } from 'types/entities'

/**
 * DSMES DASHBOARD COUNTS API CALL
 */

export function getDsmesDashboardCounts(params: Partial<IDsmesParams>, source?: CancelTokenSource) {
	const filteredParams = _.pickBy(params, _.identity)
	const promise = axios.get<IDsmesDashboardCounts>(
		onCreateEndpointsWithClientid(ENDPOINTS.DSMES_DASHBOARD_COUNT),
		{
			params: filteredParams,
		},
	)

	//@ts-ignore
	// Add cancel method to the promise
	promise.cancel = () => {
		source?.cancel(commonMessages.queryCancelledMessage)
	}

	return promise
}

/**
 * DSMES PATIENT ENROLLED API CALL
 */

export function getDsmesPatientEnrolled(params: Partial<IDsmesParams>, source?: CancelTokenSource) {
	const filteredParams = _.pickBy(params, _.identity)
	const promise = axios.get<IDsmesPatientEnrolled>(
		onCreateEndpointsWithClientid(ENDPOINTS.DSMES_DASHBOARD_PATIENT_ENROLLED),
		{
			params: filteredParams,
		},
	)

	//@ts-ignore
	// Add cancel method to the promise
	promise.cancel = () => {
		source?.cancel(commonMessages.queryCancelledMessage)
	}

	return promise
}

/**
 * DSMES BILLABLE SESSIONS API CALL
 */

export function getDsmesBillableSessions(
	params: Partial<IDsmesParams>,
	source?: CancelTokenSource,
) {
	const filteredParams = _.pickBy(params, _.identity)
	const promise = axios.get<IDsmesBillableSessions>(
		onCreateEndpointsWithClientid(ENDPOINTS.DSMES_DASHBOARD_BILLABLE_SESSIONS),
		{
			params: filteredParams,
		},
	)

	//@ts-ignore
	// Add cancel method to the promise
	promise.cancel = () => {
		source?.cancel(commonMessages.queryCancelledMessage)
	}

	return promise
}

/**
 * DSMES TOTAL COMPLETED SESSIONS API CALL
 */

export function getDsmesTotalCompletedSessions(
	params: Partial<IDsmesParams>,
	source?: CancelTokenSource,
) {
	const filteredParams = _.pickBy(params, _.identity)
	const promise = axios.get<IDsmesPatientEnrolled>(
		onCreateEndpointsWithClientid(ENDPOINTS.DSMES_DASHBOARD_TOTAL_COMPLETED_SESSIONS),
		{
			params: filteredParams,
		},
	)

	//@ts-ignore
	// Add cancel method to the promise
	promise.cancel = () => {
		source?.cancel(commonMessages.queryCancelledMessage)
	}

	return promise
}

/**
 * DSMES REGISTERED SESSIONS COMPLETED API CALL
 */

export function getDsmesRegisteredSessionsCompleted(
	params: Partial<IDsmesParams>,
	source?: CancelTokenSource,
) {
	const filteredParams = _.pickBy(params, _.identity)
	const promise = axios.get<IDsmesSessionCompleted[]>(
		onCreateEndpointsWithClientid(ENDPOINTS.DSMES_DASHBOARD_REGISTERED_SESSION),
		{
			params: filteredParams,
		},
	)

	//@ts-ignore
	promise.cancel = () => {
		source?.cancel(commonMessages.queryCancelledMessage)
	}

	return promise
}

/**
 * DSMES RETENTION RATE
 */

export function getDsmesRetentionRate(params: Partial<IDsmesParams>, source?: CancelTokenSource) {
	const filteredParams = _.pickBy(params, _.identity)
	const promise = axios.get<IDsmesPatientEnrolled>(
		onCreateEndpointsWithClientid(ENDPOINTS.DSMES_RETENTION_RATE),
		{
			params: filteredParams,
		},
	)

	//@ts-ignore
	promise.cancel = () => {
		source?.cancel(commonMessages.queryCancelledMessage)
	}

	return promise
}

/**
 * DSMES CONFERENCE
 */

export function getDsmesSessions(
	params: Partial<IDsmesParams>,
	program: string,
	source?: CancelTokenSource,
) {
	const filteredParams = _.pickBy(params, _.identity)

	const url = onCreateEndpointsWithClientid(`${ENDPOINTS.DSMES_SESSIONS}`) + '/' + program

	const promise = axios.get<IPagination<IDsmesConference>>(url, {
		params: filteredParams,
		cancelToken: source?.token,
	})

	//@ts-ignore
	promise.cancel = () => {
		source?.cancel(commonMessages.queryCancelledMessage)
	}

	return promise
}

export function getDsmesClients(params: Partial<IDsmesParams>, source?: CancelTokenSource) {
	const filteredParams = _.pickBy(params, _.identity)
	const promise = axios.get<IPagination<IDsmesClients>>(
		onCreateEndpointsWithClientid(ENDPOINTS.CLIENTS_BY_PROGRAM),
		{
			params: filteredParams,
		},
	)

	//@ts-ignore
	// Add cancel method to the promise
	promise.cancel = () => {
		source?.cancel(commonMessages.queryCancelledMessage)
	}

	return promise
}

//Get partners provider wise
export function getPartnerListProviderWise(
	params?: Partial<IDsmesParams>,
	source?: CancelTokenSource,
) {
	const filteredParams = _.pickBy(params, _.identity)
	const promise = axios.get<IPagination<Partial<any>>>(
		onCreateEndpointsWithClientid(ENDPOINTS.PARTNER_LIST_BY_PROVIDER),
		{
			params: filteredParams,
		},
	)
	//@ts-ignore
	promise.cancel = () => {
		source?.cancel(commonMessages.queryCancelledMessage)
	}
	return promise
}

// Dashboard Program List
export function getProgramListingForSuperAdmin(
	source?: CancelTokenSource,
	clientId?: string | undefined,
	params?: Partial<IDsmesParams>,
) {
	const filteredParams = _.pickBy(params, _.identity)
	const promise = axios.get(ENDPOINTS.GLOBAL_PROGRAMS_ALL + '/' + clientId, {
		params: filteredParams,
	})
	//@ts-ignore
	// Add cancel method to the promises
	promise.cancel = () => {
		source?.cancel(commonMessages.queryCancelledMessage)
	}

	return promise
}
